// How far an account is verified (实名认证), as the workplace's account
// card and the navbar's account panel both say it: a shield beside the
// name, blue once verified, and the words in the account-ID row — with
// 去认证 while it is not, which opens the 实名认证 page.
import type { RouteLocationRaw } from 'vue-router'

export interface Realname {
  label: string
  /** ok: verified; warn: not yet; pending: under review; bad: refused. */
  tone: 'ok' | 'warn' | 'pending' | 'bad'
  /** 去认证 is offered: not verified yet, or refused. */
  act: boolean
}

export function realnameOf(
  u: { realname_status?: string; realname_type?: string } | null | undefined,
  t: (key: string) => string,
): Realname {
  switch (u?.realname_status) {
    case 'verified':
      return { label: t(u.realname_type === 'enterprise' ? 'navbar.rnEnterprise' : 'navbar.rnIndividual'), tone: 'ok', act: false }
    case 'pending':
      return { label: t('navbar.rnPending'), tone: 'pending', act: false }
    case 'rejected':
      return { label: t('navbar.rnRejected'), tone: 'bad', act: true }
    default:
      return { label: t('navbar.rnNone'), tone: 'warn', act: true }
  }
}

/** 去认证: 账户中心's 实名认证 tab. */
export const REALNAME_PAGE: RouteLocationRaw = { name: 'account-center', query: { tab: 'realname' } }
